import React from "react";

const InquiryList = React.lazy(() => import("./InquiryList"));

export default {
  list: InquiryList,
};
